import React, { Fragment } from "react";
import { Table, Button, Badge } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

const CrowdContentOrdersReadyOrdersTable = (props) => {
  const { contentOrders, setFocusedCrowdContentOrder } = props;

  const appearShorter = (title) => {
    if (title.length > 35) {
      title = title.substring(0, 32) + "...";
    }
    return title;
  };

  const showPriorityBadge = (priority) => {
    switch (priority) {
      case "High Priority":
        return (
          <Badge color="danger" style={{ "margin-left": "10px" }} pill>
            High Priority
          </Badge>
        );
      case "Onboarding Order":
        return (
          <Badge color="warning" style={{ "margin-left": "10px" }} pill>
            Onboarding
          </Badge>
        );
      default:
        break;
    }
  };

  const showIMOBadge = (marketingType) => {
    switch (marketingType) {
      case "IMO":
        return (
          <Badge color="info" style={{ "margin-left": "10px" }} pill>
            IMO
          </Badge>
        );
      default:
        break;
    }
  };

  const determineQuality = (quality) => {
    let qualityStars = "";
    for (let i = 0; i < quality; i++) {
      qualityStars.concat("<FontAwesomeIcon Icon={faStar}> ");
    }
    console.log(qualityStars);
  };

  return (
    <Fragment>
      {contentOrders.length === 0 ? (
        <span>
          There are no orders ready for review at this time. Check back soon.
        </span>
      ) : (
        <Table size="sm" hover>
          <tbody>
            {contentOrders.map((order) => (
              <tr>
                <td className="pt-2">
                  <a
                    href={`https://www.stellarcontent.com/client/orders/view/${order.order_id}#summary`}
                    target="_blank"
                  >
                    <span>{order.order_id}</span>
                  </a>
                </td>
                {order.meta ? (
                  <td className="pt-2">
                    <a href={`/project/view/${order.meta.project._id}`}>
                      {appearShorter(
                        order.meta.project.meta.parent.local.business.name
                      )}
                      {showPriorityBadge(order.meta.orderPriority)}
                      {showIMOBadge(order.meta.project.local.marketingType)}
                    </a>
                  </td>
                ) : (
                  <td className="pt-2">
                  </td>
                )}
                <td className="pt-2">{appearShorter(order.title)}</td>
                <td className="pt-2">{`${order.min_word_count}/${order.max_word_count}`}</td>
                <td className="pt-2">{`$${order.max_cost}`}</td>
                <td className="pt-2">{`${order.quality} Star`}</td>
                <td className="text-right">
                  <Button
                    size="sm"
                    color="success"
                    onClick={() => setFocusedCrowdContentOrder(order)}
                  >
                    Review Now
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Fragment>
  );
};

export default CrowdContentOrdersReadyOrdersTable;
